module.exports = __webpack_public_path__ + "static/img/Maple Shale Grey.a595d61.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Maple Shale Grey.jpg
// module id = EOWL
// module chunks = 0